let tzCurrentLineItemKey = null;
let currentQty = 1;

const qtyInput = document.querySelector('.js-qty');
const plusBtn = document.querySelector('[data-increase-quantity]');
const minusBtn = document.querySelector('[data-decrease-quantity]');

if (qtyInput) {
  const step = parseInt(qtyInput.getAttribute('step'), 10) || 1;
  const min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
  const max = parseInt(qtyInput.getAttribute('data-max'), 10) || Infinity;

  currentQty = parseInt(qtyInput.value, 10) || min;

  function updateQtyDisplay() {
    qtyInput.value = currentQty;
    qtyInput.dispatchEvent(new Event('change'));
  }

  plusBtn?.addEventListener('click', () => {
    currentQty = Math.min(max, currentQty + step);
    updateQtyDisplay();
  });

  minusBtn?.addEventListener('click', () => {
    currentQty = Math.max(min, currentQty - step);
    updateQtyDisplay();
  });

  qtyInput.addEventListener('change', function (e) {
    const input = e.target;
    if (input && input.matches('[data-b2b-input]')) {
      let value = parseInt(input.value, 10);
      if (value !== max && value % 3 !== 0) {
        value = Math.ceil(value / 3) * 3;
        if (value > max) value = max;
        input.value = value;
        
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      currentQty = value;
    }
  });
}

// Mutex flag to prevent concurrent executions and duplicate gift additions
let isCheckingGifts = false;

async function checkAndAddGifts() {
  // Prevent concurrent executions
  if (isCheckingGifts) {
    console.log('⏳ Gift check already in progress, skipping...');
    return;
  }

  const rules = window.autoGiftRules;
  console.log(rules, '🎯 autoGiftRules');

  if (!rules || !Array.isArray(rules) || rules.length === 0) return;

  isCheckingGifts = true;
  
  try {
    const cart = await fetch('/cart.js').then(res => res.json());

    for (const rule of rules) {
      const giftVariantId = rule.variantId;
      const tag = rule.tag;
      const threshold = rule.threshold;

      // Skip rule if variant ID is missing or invalid
      if (!giftVariantId || giftVariantId === null) {
        console.warn(`⚠️ Skipping gift rule for tag "${tag}" - no valid variant ID configured`);
        continue;
      }

      let subtotal = 0;
      let giftItem = null;

      for (const item of cart.items) {
        if (!item.handle) continue;

        // Fixed: Check variant_id instead of id to properly detect existing gifts
        if (item.variant_id === giftVariantId) {
          giftItem = item;
          continue; // ne računamo gift u subtotal
        }

        const product = await fetch(`/products/${item.handle}.js`).then(r => r.json());
        if (product.tags.includes(tag)) {
          subtotal += item.line_price / 100;
        }
      }

      console.log(`[GIFT CHECK] Subtotal for tag "${tag}" = $${subtotal} / threshold = $${threshold}`);

      if (subtotal >= threshold) {
        if (!giftItem) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: giftVariantId,
                quantity: 1,
                properties: { auto_gift: true }
              }]
            })
          });
          
          // Fetch fresh cart state after adding
          await fetch('/cart.js').then(res => res.json());
          
          console.log(`🎁 Gift "${giftVariantId}" ADDED for tag "${tag}"`);
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        }
      } else {
        if (giftItem) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: giftItem.key,
              quantity: 0
            })
          });
          
          // Fetch fresh cart state after removing
          await fetch('/cart.js').then(res => res.json());
          
          console.log(`🗑️ Gift "${giftVariantId}" REMOVED for tag "${tag}"`);
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        }
      }
    }
  } catch (err) {
    console.error('❌ Error in checkAndAddGifts():', err);
  } finally {
    // Always clear the flag, even if there's an error
    isCheckingGifts = false;
  }
}
async function updateCartSubtotalUI() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const subtotal = cart.total_price / 100;

    setTimeout(() => {
      const finalPriceEl = document.querySelector('[data-cart-final]');
      if (!finalPriceEl) {
        console.warn('⚠️ data-cart-final element not found.');
        return;
      }

      const original = finalPriceEl.textContent;
      const numberRegex = /[\d.,]+/;
      const match = original.match(numberRegex);

      if (!match) {
        console.warn('❌ No number found in:', original);
        return;
      }

      const oldValue = match[0];
      let formatted;

      // Detekcija stila decimalnog separatora
      if (/,\d{2}$/.test(oldValue)) {
        formatted = subtotal.toFixed(2).replace('.', ',');
      } else if (/\.\d{2}$/.test(oldValue)) {
        formatted = subtotal.toFixed(2); // US-style
      } else {
        formatted = Math.round(subtotal).toString();
      }

      const updated = original.replace(numberRegex, formatted);
      finalPriceEl.textContent = updated;

      console.log('✅ Subtotal manually updated to:', updated);
    }, 500);
  } catch (err) {
    console.error('❌ Failed to update subtotal UI:', err);
  }
}




document.addEventListener('theme:cart:change', async () => {
  await checkAndAddGifts();
  updateCartSubtotalUI();
});

async function addItemsOneByOne(items) {
  for (const item of items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item)
    });

    if (!res.ok) {
      const errorText = await res.text();
      console.error(`❌ Greška prilikom dodavanja varijante ${item.id}:`, errorText);
    }
  }

  // Pokreće se popup kad se sve doda
  const mainItem = items[0];
  if (mainItem?.id) {
    showPopup({ id: mainItem.id });
  }

  document.querySelector('.header__inner')?.setAttribute('data-header-cart-full', 'true');

  document.dispatchEvent(new CustomEvent('theme:cart:change', {
    detail: { cart: null },
    bubbles: true
  }));
}

// Use event delegation to handle dynamically added elements after filtering
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-product-id]');
  if (!button) return;

  if (button.classList.contains('add-gift-button')) return;

  event.preventDefault();
  const isMain = button.dataset.scope === 'main';
  console.log('Button clicked:', button, 'isMain:', isMain);
  
  // Read quantity from the button's form (supports both main and sticky ATC)
  const buttonForm = button.closest('form');
  const formQtyInput = buttonForm ? buttonForm.querySelector('input[name="quantity"]') : null;
  if (formQtyInput) {
    currentQty = parseInt(formQtyInput.value, 10) || 1;
    console.log('Updated currentQty from form:', currentQty);
  }

  if (!button.getAttribute('type')) {
    button.setAttribute('type', 'button');
  }

  const mainId = parseInt(button.getAttribute('data-product-id'), 10);
    const items = [];
    let tzSelfKey = null;
    let addedAt = null;
    let hasAddons = false;

    // === ENGRAVING BLOK (safety gated) ===
    const engravingBtn = document.querySelector('.js-activate-engraving');
    const engravingSection = document.querySelector('.js-engraving-fields');
    let engravingActive = false;
    let engravingVariantId = null;
    let engravingProps = {};

    if (isMain && engravingBtn && engravingSection && !engravingSection.classList.contains('hidden')) {
      engravingActive = true;
      hasAddons = true;
      tzSelfKey = `tz_${Date.now()}`;
      addedAt = Date.now().toString();

      engravingVariantId = parseInt(engravingBtn.dataset.variantId || '0', 10);
      const engravingText = document.querySelector('.js-engraving-text')?.value.trim() || '';
      const engravingFont = document.querySelector('.js-engraving-font')?.value || '';
      const engravingSymbol = document.querySelector('.js-engraving-symbol')?.value || '';
      const engravingPosition = Array.from(document.querySelectorAll('input[name="symbolPosition"]')).find(input => input.checked)?.value || 'before';
      const engravingTerms = document.querySelector('.js-engraving-terms');
      const engravingErrorBox = document.querySelector('.js-engraving-error');

      if (!engravingTerms?.checked) {
        engravingErrorBox?.classList.remove('hidden');
        if (engravingErrorBox) engravingErrorBox.textContent = 'Please accept the Terms & Conditions for engraving.';
        return;
      } else {
        engravingErrorBox?.classList.add('hidden');
      }

      engravingProps = {
        'Engraving text': engravingText,
        'Engraving font': engravingFont,
        _tz_parent_key: tzSelfKey
      };

      if (engravingSymbol) {
        engravingProps['Engraving symbol'] = engravingSymbol;
        engravingProps['Symbol position'] = engravingPosition;
      } else {
        engravingProps['Symbol position'] = 'No symbol';
      }
    }

    // === GIFT WRAP BLOK (safety gated) ===
    const giftBtn = document.querySelector('.js-activate-gift');
    const giftSection = document.querySelector('.js-gift-message');
    let giftActive = false;
    let giftVariantId = null;
    let giftProps = {};

    if (isMain && giftBtn && giftSection && !giftSection.classList.contains('hidden')) {
      giftActive = true;
      hasAddons = true;
      if (!tzSelfKey) {
        tzSelfKey = `tz_${Date.now()}`;
        addedAt = Date.now().toString();
      }

      giftVariantId = parseInt(giftBtn.getAttribute('data-variant-id') || '0', 10);
      const giftMessageInput = document.querySelector('.js-gift-message-area');
      const giftMessage = giftMessageInput ? giftMessageInput.value.trim() : '';
      const giftTerms = document.querySelector('.js-gift-terms');
      const giftErrorBox = document.querySelector('.js-gift-error');

      if (!giftTerms?.checked) {
        giftErrorBox?.classList.remove('hidden');
        if (giftErrorBox) giftErrorBox.textContent = 'Please accept the Terms & Conditions for gift wrap.';
        return;
      } else {
        giftErrorBox?.classList.add('hidden');
      }

      giftProps = {
        _tz_parent_key: tzSelfKey
      };

      if (giftMessage) {
        giftProps['Gift message'] = giftMessage;
      }
    }

    // === MAIN PRODUCT ===
    const mainItemProps = {};

    if (hasAddons) {
      if (addedAt) mainItemProps._tz_added_at = addedAt;
      if (engravingActive) mainItemProps._tz_custom_engraving = true;
      if (giftActive) mainItemProps._tz_custom_gift_wrap = true;
      if (tzSelfKey) mainItemProps._tz_self_key = tzSelfKey;
    }
    // Add tag override for min qty
    const hasNoMinQty = button.dataset.noMinQty === 'true';
    if (hasNoMinQty) {
      mainItemProps._tag_no_min_qty = 'true';
    }

    let finalQty;
    let minQty = document.querySelector('body').getAttribute('data-minimum-qty') || 1;

    if (isMain || hasNoMinQty) {
      finalQty = currentQty
    } else {
      finalQty = minQty; // za child varijante u slučaju da nije main
    }

    items.push({
      id: mainId,
      quantity: finalQty,
      ...(Object.keys(mainItemProps).length ? { properties: mainItemProps } : {})
    });

    // === ENGRAVING ITEM ===
    if (engravingActive && engravingVariantId && !isNaN(engravingVariantId)) {
      items.push({
        id: engravingVariantId,
        quantity: currentQty,
        properties: engravingProps
      });
    }

    // === GIFT ITEM ===
    if (giftActive && giftVariantId && !isNaN(giftVariantId)) {
      items.push({
        id: giftVariantId,
        quantity: currentQty,
        properties: giftProps
      });
    }

    // === AJAX SLANJE U KORPU ===
    addItemsOneByOne(items)
});



const main = document.querySelector('body');

let isGiftWrapAdded = false;
let isEngravingAdded = false;
let originalMainId = null;
let originalPrice = null;

// Cookie helpers
function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
}

function getCookie(name) {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r
  }, '');
}

function deleteCookie(name) {
  document.cookie = name + '=; Max-Age=0; path=/';
}

document.addEventListener('DOMContentLoaded', () => {
  const isPetOnlyB2b = main && main.dataset.petOnlyB2b === 'true';

  if (isPetOnlyB2b) {
    setCookie('pet_mode', '1', 30);
    main.classList.add('pets');
    return;
  }

  // Reset na home pageu
  if (window.location.pathname === '/') {
    deleteCookie('pet_mode');
  }
  // if page title contains 'pet' or if product template name contains 'pet'
  const pageTitle = document.title;
  const templateName = document.querySelector('body').getAttribute('data-tempsuffix');

  if (pageTitle.includes('pet') || templateName.includes('pet')) {
    setCookie('pet_mode', '1', 30);
    main.classList.add('pets');
  } else {
    deleteCookie('pet_mode');
    main.classList.remove('pets');
  }

  const isPetMode = getCookie('pet_mode') === '1';
  if (isPetMode) {
    main.classList.add('pets');
  } else {
    main.classList.remove('pets');
  }

  

});

// Switcheri
document.getElementById('switch-to-pets')?.addEventListener('click', () => {
  setCookie('pet_mode', '1', 30);
  main.classList.add('pets');
});

document.getElementById('switch-to-humans')?.addEventListener('click', () => {
  if (main && main.dataset.petOnlyB2b === 'true') {
    return;
  }

  deleteCookie('pet_mode');
  main.classList.remove('pets');
});

function initEngravingUI() {
  const engravingBtn = document.querySelector('.js-activate-engraving');
  const engravingSection = document.querySelector('.js-engraving-fields');
  const engravingCloseBtn = document.querySelector('.js-close-engraving');
  const engravingText = document.querySelector('.js-engraving-text');
  const engravingSymbol = document.querySelector('.js-engraving-symbol');
  const engravingFont = document.querySelector('.js-engraving-font');
  const engravingPreview = document.querySelector('.js-engraving-preview-text');
  const symbolPositionInputs = document.querySelectorAll('.js-symbol-position');
  const symbolPositionWrapper = document.querySelector('.js-symbol-position-wrapper');
  const tocCheckbox = document.querySelector('.js-engraving-terms');
  const errorBox = document.querySelector('.js-engraving-error');
  const atcButton = document.querySelector('[data-product-id]');

  let isEngravingActive = false;
  let emojiErrorBox = null;

  if (!engravingBtn || !engravingSection) return;

  // Create emoji error notification box
  function createEmojiErrorBox() {
    if (!emojiErrorBox) {
      emojiErrorBox = document.createElement('div');
      emojiErrorBox.className = 'js-engraving-emoji-error hidden';
      emojiErrorBox.textContent = 'Special Characters outside of the selected symbol will not be included';
      
      // Insert after the engraving text input
      if (engravingText && engravingText.parentNode) {
        engravingText.parentNode.insertBefore(emojiErrorBox, engravingText.nextSibling);
      }
    }
    return emojiErrorBox;
  }

  // Function to detect emojis in text
  function containsEmoji(text) {
    // Regex to match emojis including:
    // - Emoticons (U+1F600-U+1F64F)
    // - Symbols & Pictographs (U+1F300-U+1F5FF)
    // - Transport & Map Symbols (U+1F680-U+1F6FF)
    // - Miscellaneous Symbols (U+2600-U+26FF)
    // - Dingbats (U+2700-U+27BF)
    // - Supplemental Symbols (U+1F900-U+1F9FF)
    // - Enclosed characters (U+24C2-U+1F251)
    const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E0}-\u{1F1FF}\u{1F191}-\u{1F251}\u{1F004}\u{1F0CF}\u{1F170}-\u{1F171}\u{1F17E}-\u{1F17F}\u{1F18E}\u{3030}\u{2B50}\u{2B55}\u{2934}-\u{2935}\u{2B05}-\u{2B07}\u{2B1B}-\u{2B1C}\u{3297}\u{3299}\u{303D}\u{00A9}\u{00AE}\u{2122}\u{23F3}\u{24C2}\u{23E9}-\u{23EF}\u{25AA}-\u{25AB}\u{25B6}\u{25C0}\u{25FB}-\u{25FE}\u{2600}-\u{2604}\u{260E}\u{2611}\u{2614}-\u{2615}\u{2618}\u{261D}\u{2620}\u{2622}-\u{2623}\u{2626}\u{262A}\u{262E}-\u{262F}\u{2638}-\u{263A}\u{2640}\u{2642}\u{2648}-\u{2653}\u{2660}\u{2663}\u{2665}-\u{2666}\u{2668}\u{267B}\u{267F}\u{2692}-\u{2697}\u{2699}\u{269B}-\u{269C}\u{26A0}-\u{26A1}\u{26AA}-\u{26AB}\u{26B0}-\u{26B1}\u{26BD}-\u{26BE}\u{26C4}-\u{26C5}\u{26C8}\u{26CE}\u{26CF}\u{26D1}\u{26D3}-\u{26D4}\u{26E9}-\u{26EA}\u{26F0}-\u{26F5}\u{26F7}-\u{26FA}\u{26FD}]/u;
    return emojiRegex.test(text);
  }

  // Function to remove emojis from text
  function removeEmojis(text) {
    const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E0}-\u{1F1FF}\u{1F191}-\u{1F251}\u{1F004}\u{1F0CF}\u{1F170}-\u{1F171}\u{1F17E}-\u{1F17F}\u{1F18E}\u{3030}\u{2B50}\u{2B55}\u{2934}-\u{2935}\u{2B05}-\u{2B07}\u{2B1B}-\u{2B1C}\u{3297}\u{3299}\u{303D}\u{00A9}\u{00AE}\u{2122}\u{23F3}\u{24C2}\u{23E9}-\u{23EF}\u{25AA}-\u{25AB}\u{25B6}\u{25C0}\u{25FB}-\u{25FE}\u{2600}-\u{2604}\u{260E}\u{2611}\u{2614}-\u{2615}\u{2618}\u{261D}\u{2620}\u{2622}-\u{2623}\u{2626}\u{262A}\u{262E}-\u{262F}\u{2638}-\u{263A}\u{2640}\u{2642}\u{2648}-\u{2653}\u{2660}\u{2663}\u{2665}-\u{2666}\u{2668}\u{267B}\u{267F}\u{2692}-\u{2697}\u{2699}\u{269B}-\u{269C}\u{26A0}-\u{26A1}\u{26AA}-\u{26AB}\u{26B0}-\u{26B1}\u{26BD}-\u{26BE}\u{26C4}-\u{26C5}\u{26C8}\u{26CE}\u{26CF}\u{26D1}\u{26D3}-\u{26D4}\u{26E9}-\u{26EA}\u{26F0}-\u{26F5}\u{26F7}-\u{26FA}\u{26FD}]/gu;
    return text.replace(emojiRegex, '');
  }

  // Function to show emoji error notification
  function showEmojiError() {
    const emojiError = createEmojiErrorBox();
    if (emojiError) {
      emojiError.classList.remove('hidden');
      
      // Auto-hide after 3 seconds
      setTimeout(() => {
        emojiError.classList.add('hidden');
      }, 3000);
    }
  }

  function updatePreview() {
    const text = engravingText?.value || '';
    const symbol = engravingSymbol?.value || '';
    const font = engravingFont?.value || 'sans-serif';

    let position = 'before';
    symbolPositionInputs.forEach(input => {
      if (input.checked) position = input.value;
    });

    const limit = symbol ? 13 : 15;
    if (text.length > limit) {
      engravingText.value = text.slice(0, limit);
    }

    if (symbolPositionWrapper) {
      symbolPositionWrapper.classList.toggle('hidden', symbol === '');
    }

    if (engravingPreview) {
      engravingPreview.style.fontFamily = font;

      let previewText = text;

      if (symbol) {
        previewText =
          position === 'after'
            ? `${text} ${symbol}`
            : `${symbol} ${text}`;
      }

      engravingPreview.textContent = previewText.trim();
    }
  }
  function resetEngravingInputs() {
    engravingText.value = '';
    engravingSymbol.value = '';
    engravingFont.value = '';
    symbolPositionInputs.forEach(input => input.checked = false);
    const engravingTerms = document.querySelector('.js-engraving-terms');
    if (engravingTerms) engravingTerms.checked = false;
    updatePreview();
  }


  function disableATC() {
    atcButton?.setAttribute('disabled', 'true');
    atcButton?.classList.add('opacity-50', 'pointer-events-none');
  }

  function enableATC() {
    atcButton?.removeAttribute('disabled');
    atcButton?.classList.remove('opacity-50', 'pointer-events-none');
    errorBox?.classList.add('hidden');
  }

  function validateEngravingFields() {
    if (!isEngravingActive) {
      enableATC();
      return;
    }

    const hasText = engravingText?.value.trim().length > 0;
    const tocChecked = tocCheckbox?.checked;

    if (hasText && tocChecked) {
      enableATC();
    } else {
      disableATC();
    }
  }

  engravingBtn.addEventListener('click', () => {
    isEngravingActive = !isEngravingActive;
    engravingBtn.classList.toggle('engraving-active', isEngravingActive);
    engravingSection.classList.toggle('hidden', !isEngravingActive);

    if (isEngravingActive) {
      updatePreview();
      validateEngravingFields();
    } else {
      enableATC();
      resetEngravingInputs();
    }
  });

  engravingCloseBtn?.addEventListener('click', () => {
    isEngravingActive = false;
    engravingBtn.classList.remove('engraving-active');
    engravingSection.classList.add('hidden');
    enableATC();
    resetEngravingInputs();
  });

  tocCheckbox?.addEventListener('change', validateEngravingFields);
  
  // Handle paste event to block emojis
  engravingText?.addEventListener('paste', (e) => {
    e.preventDefault();
    const pastedText = (e.clipboardData || window.clipboardData).getData('text');
    
    if (containsEmoji(pastedText)) {
      showEmojiError();
      // Insert text without emojis
      const cleanText = removeEmojis(pastedText);
      const currentValue = engravingText.value;
      const start = engravingText.selectionStart;
      const end = engravingText.selectionEnd;
      
      engravingText.value = currentValue.substring(0, start) + cleanText + currentValue.substring(end);
      engravingText.selectionStart = engravingText.selectionEnd = start + cleanText.length;
    } else {
      // Paste normally if no emojis
      const currentValue = engravingText.value;
      const start = engravingText.selectionStart;
      const end = engravingText.selectionEnd;
      
      engravingText.value = currentValue.substring(0, start) + pastedText + currentValue.substring(end);
      engravingText.selectionStart = engravingText.selectionEnd = start + pastedText.length;
    }
    
    updatePreview();
    validateEngravingFields();
  });
  
  // Handle input event to block emojis typed directly
  engravingText?.addEventListener('input', (e) => {
    const currentValue = engravingText.value;
    
    if (containsEmoji(currentValue)) {
      showEmojiError();
      // Remove emojis from the input
      const cleanValue = removeEmojis(currentValue);
      const cursorPos = engravingText.selectionStart;
      engravingText.value = cleanValue;
      // Try to maintain cursor position
      engravingText.selectionStart = engravingText.selectionEnd = Math.min(cursorPos, cleanValue.length);
    }
    
    updatePreview();
    validateEngravingFields();
  });

  engravingSymbol?.addEventListener('input', updatePreview);
  engravingFont?.addEventListener('change', updatePreview);

  symbolPositionInputs.forEach(input => {
    input?.addEventListener('change', updatePreview);
  });
}




function initGiftWrapUI() {
  const giftBtn = document.querySelector('.js-activate-gift');
  const giftSection = document.querySelector('.js-gift-message');
  const giftCloseBtn = document.querySelector('.js-close-gift');
  const tocCheckbox = document.querySelector('.js-gift-terms');
  const errorBox = document.querySelector('.js-gift-error');
  const atcButton = document.querySelector('[data-product-id]');

  let isGiftActive = false;

  if (!giftBtn || !giftSection) return;

  function disableATC() {
    atcButton?.setAttribute('disabled', 'true');
    atcButton?.classList.add('opacity-50', 'pointer-events-none');
  }
  function resetGiftInputs() {
    const giftMessageInput = document.querySelector('.js-gift-message-area');
    const giftTerms = document.querySelector('.js-gift-terms');
    const giftErrorBox = document.querySelector('.js-gift-error');

    if (giftMessageInput) giftMessageInput.value = '';
    if (giftTerms) giftTerms.checked = false;
    if (giftErrorBox) {
      giftErrorBox.classList.add('hidden');
      giftErrorBox.textContent = '';
    }
  }

  function enableATC() {
    const engravingActive = document.querySelector('.js-activate-engraving')?.classList.contains('engraving-active');
    const engravingTermsChecked = document.querySelector('.js-engraving-terms')?.checked;
    const giftTermsChecked = tocCheckbox?.checked;

    const engravingOk = !engravingActive || engravingTermsChecked;
    const giftOk = !isGiftActive || giftTermsChecked;

    if (engravingOk && giftOk) {
      atcButton?.removeAttribute('disabled');
      atcButton?.classList.remove('opacity-50', 'pointer-events-none');
      errorBox?.classList.add('hidden');
    } else {
      disableATC();
    }
  }

  giftBtn.addEventListener('click', () => {
    isGiftActive = !isGiftActive;
    giftBtn.classList.toggle('gift-active', isGiftActive);
    giftSection.classList.toggle('hidden', !isGiftActive);
    enableATC();
    if (!isGiftActive) resetGiftInputs();
  });

  giftCloseBtn?.addEventListener('click', () => {
    isGiftActive = false;
    giftBtn.classList.remove('gift-active');
    giftSection.classList.add('hidden');
    enableATC();
    resetGiftInputs();
  });

  tocCheckbox?.addEventListener('change', () => {
    enableATC();
  });
}

function bindClosePopup() {
  document.querySelectorAll('.js-atc-close').forEach(btn => {
    btn.addEventListener('click', () => {
      document.getElementById('tz-atc-overlay')?.classList.add('hidden');
       releaseFocusTrap(document.getElementById('tz-atc-modal'));
      console.log('Overlay clicked, hiding popup', lastFocusedElement);
       if (lastFocusedElement) {
        lastFocusedElement.focus();
      }
    });
  });

  document.getElementById('tz-atc-overlay')?.addEventListener('click', (e) => {
    if (e.target.id === 'tz-atc-overlay') {
      e.currentTarget.classList.add('hidden');
       releaseFocusTrap(document.getElementById('tz-atc-modal'));
       console.log('Overlay clicked, hiding popup', lastFocusedElement);
       if (lastFocusedElement) {
        lastFocusedElement.focus();
      }
    }
  });
}

function trapFocus(modal) {
  const focusableSelectors = `
    a[href], button:not([disabled]), textarea, input:not([type="hidden"]),
    select, [tabindex]:not([tabindex="-1"])
  `;
  const focusableElements = Array.from(modal.querySelectorAll(focusableSelectors))
    .filter(el => el.offsetParent !== null); // visible elements only

  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];

  function handleTab(e) {
    if (e.key !== 'Tab') return;

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  modal.dataset.focusTrapHandler = handleTab;
  modal.addEventListener('keydown', handleTab);
  first?.focus();
}

function releaseFocusTrap(modal) {
  if (modal._focusTrapHandler) {
    modal.removeEventListener('keydown', modal._focusTrapHandler);
    delete modal._focusTrapHandler;
  }
}

let lastFocusedElement;

function normalizeB2bQuantity(input, value, min = 1) {
  const max = parseInt(input.getAttribute('data-max'), 10) || Infinity;
  let v = parseInt(value, 10);
  if (isNaN(v)) v = min;
  v = Math.min(max, Math.max(min, v));
  if (input.hasAttribute('data-b2b-input') && v % 3 !== 0 && v !== max) {
    v = Math.min(max, Math.ceil(v / 3) * 3);
  }
  return v;
}

function showPopup(data) {
  if (!data || !data.id) return;
  lastFocusedElement = document.activeElement;
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartItem = cart.items.find(item => item.variant_id === data.id);
      if (!cartItem) {
        console.warn('❌ Cart item not found for variant:', data.id);
        return;
      }

      tzCurrentLineItemKey = cartItem.key;

      const overlay = document.getElementById('tz-atc-overlay');
      if (!overlay) return;

      document.getElementById('tz-atc-title').textContent = cartItem.product_title;
      document.getElementById('tz-atc-image').src = cartItem.image;
      const qtyEl = document.getElementById('tz-atc-qty');
      const oldValue = qtyEl.value;
      const qtyMax = parseInt(qtyEl.getAttribute('data-max'), 10) || Infinity;
      qtyEl.value = Math.min(qtyMax, cartItem.quantity);
      document.getElementById('tz-atc-count').textContent = cart.item_count;
      document.getElementById('tz-atc-subtotal').textContent = formatMoney(cart.total_price);
      setTimeout(() => {
        updatePopupQuantity(1, qtyEl.value);
      }, 100)


      // === FREE SHIPPING LOGIKA ===
      const threshold = parseInt(overlay.dataset.shippingThreshold || '0', 10);
      const total = cart.total_price / 100;
      const freeShippingNote = document.getElementById('tz-atc-free-shipping');
      const freeShippingNoteSecondLine = document.getElementById('tz-atc-free-shipping-second-line');
      const t = (key, vars = {}) => {
        const el = document.getElementById('CartPopupTranslations');
        let str = el?.dataset?.[key] || '';
        Object.keys(vars).forEach(k => {
          str = str.replace(`{{${k}}}`, vars[k]);
        });
        return str;
      };
      if (freeShippingNote) {
        if (total >= threshold) {
          freeShippingNote.textContent = t('freeShippingUnlocked');
          freeShippingNoteSecondLine.textContent = t('freeShippingRemainSecondLine');
        } else {
          const remain = threshold - total;
          freeShippingNote.textContent = t('freeShippingRemain', {
            amount: formatMoney(Math.round(remain * 100))
          });
          freeShippingNoteSecondLine.textContent = t('freeShippingRemainSecondLine');
        }
      }

      // === FREE GIFT LOGIKA ===
      const continueBtn = document.querySelector('#tz-atc-modal .continue-shopping');
      const drawerTrigger = document.querySelector('[data-drawer-toggle="drawer-cart"]');
      const giftThresholds = window.tzFreeGiftsConfig?.thresholds || [];

      const unlockedGift = giftThresholds.find(t => cart.total_price >= t.amount);
      if (unlockedGift && continueBtn && drawerTrigger) {
        const giftTaken = cart.items.some(item =>
          item.properties && item.properties._gift_series_threshold == unlockedGift.amount
        );

        if (!giftTaken) {
          continueBtn.textContent = t('chooseYourGift');
          continueBtn.addEventListener('click', (e) => {
            e.preventDefault();
            drawerTrigger.click();
          }, { once: true });
        }
      }

      overlay.classList.remove('hidden');
      const modal = document.getElementById('tz-atc-modal');
      trapFocus(modal);

       console.log('Triggering theme:cart:change event with cart data');
      document.dispatchEvent(new CustomEvent('theme:cart:change', {
        detail: { cart }, // pass the actual cart object
        bubbles: true
      }));
    });


}

async function updatePopupQuantity(diff, customValue = undefined) {
  const qtyInput = document.getElementById('tz-atc-qty');
  if (!qtyInput || !tzCurrentLineItemKey) return;

  const cart = await fetch('/cart.js').then(res => res.json());
  const item = cart.items.find(i => i.key === tzCurrentLineItemKey);
  if (!item) return;

  // Dynamic min qty based on product tag
  console.log('Item tags:', item , item.tags);
  const isExempt = item.properties && item.properties._tag_no_min_qty === 'true';

  const minimumQty = isExempt ? 1 : parseInt(document.querySelector('body').getAttribute('data-minimum-qty') || '1', 10);
  console.log('Minimum quantity:', minimumQty, 'Exempt:', isExempt);
  // if it is not exempt, diff should be aligned to minimun qty to respect the step  
  let realdiff = diff;
  if (diff == 1 && !isExempt) {
    realdiff = minimumQty;
  } else if ( diff == -1 && !isExempt) {
    realdiff = -minimumQty;
  }
  
  const qtyMax = parseInt(qtyInput.getAttribute('data-max'), 10) || Infinity;
  let newQty;
  newQty = parseInt(qtyInput.value || '1', 10) + realdiff;

  
  console.log('Current qty:', qtyInput.value, 'Diff:', realdiff, 'New qty:', newQty);
  if (newQty < minimumQty) newQty = minimumQty;
  if (newQty > qtyMax) newQty = qtyMax;

  qtyInput.setAttribute('data-product-id-qty', item.id);
  const myId = Number(qtyInput.dataset.productIdQty);
  const myItem = cart.items.find(i => i.variant_id === myId);
  if (!myItem) return;

  if(customValue !== undefined) {
    newQty = customValue;
  }

  newQty = normalizeB2bQuantity(qtyInput, newQty, minimumQty);

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: myItem.key, quantity: newQty })
  })
    .then(res => res.json())
    .then(cart => {
      const updatedItem = cart.items.find(i => i.variant_id === myId);
      if (!updatedItem) return;

      document.getElementById('tz-atc-qty').value = updatedItem.quantity;
      document.getElementById('tz-atc-count').textContent = cart.item_count;
      document.getElementById('tz-atc-subtotal').textContent = formatMoney(cart.total_price);

      const overlay = document.getElementById('tz-atc-overlay');
      const threshold = parseInt(overlay.dataset.shippingThreshold || '0', 10);
      const total = cart.total_price / 100;
      const freeShippingNote = document.getElementById('tz-atc-free-shipping');
      const freeShippingNoteSecondLine = document.getElementById('tz-atc-free-shipping-second-line');
      const t = (key, vars = {}) => {
        const el = document.getElementById('CartPopupTranslations');
        let str = el?.dataset?.[key] || '';
        Object.keys(vars).forEach(k => {
          str = str.replace(`{{${k}}}`, vars[k]);
        });
        return str;
      };
      if (freeShippingNote) {
        if (total >= threshold) {
          freeShippingNote.textContent = t('freeShippingUnlocked');
          freeShippingNoteSecondLine.textContent = t('freeShippingRemainSecondLine');
        } else {
          const remain = threshold - total;
          freeShippingNote.textContent = t('freeShippingRemain', {
            amount: formatMoney(Math.round(remain * 100))
          });
          freeShippingNoteSecondLine.textContent = t('freeShippingRemainSecondLine');
        }
      }

      // Event za header refresh (ako ti treba)
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart } }));
      const continueBtn = document.querySelector('#tz-atc-modal .continue-shopping');
      const drawerTrigger = document.querySelector('[data-drawer-toggle="drawer-cart"]');
      const thresholds = window.tzFreeGiftsConfig?.thresholds || [];

      const unlocked = thresholds.find(t => cart.total_price >= t.amount);
      const taken = unlocked && cart.items.some(item =>
        item.properties && item.properties._gift_series_threshold == unlocked.amount
      );

      if (unlocked && !taken && continueBtn && drawerTrigger) {
        continueBtn.textContent = '🎁 Choose Your Gift';
        continueBtn.onclick = (e) => {
          e.preventDefault();
          drawerTrigger.click();
        };

        if (freeShippingNote) {
          if (total >= threshold) {
            freeShippingNote.textContent = t('freeShippingUnlocked');
          } else {
            const remain = threshold - total;
            freeShippingNote.textContent = t('freeShippingRemain', {
              amount: formatMoney(Math.round(remain * 100))
            });
          }
        }

        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart } }));

        const continueBtn = document.querySelector('#tz-atc-modal .continue-shopping');
        const drawerTrigger = document.querySelector('[data-drawer-toggle="drawer-cart"]');
        const thresholds = window.tzFreeGiftsConfig?.thresholds || [];

        const unlocked = thresholds.find(t => cart.total_price >= t.amount);
        const taken = unlocked && cart.items.some(item =>
          item.properties && item.properties._gift_series_threshold == unlocked.amount
        );

        if (unlocked && !taken && continueBtn && drawerTrigger) {
          continueBtn.textContent = '🎁 Choose Your Gift';
          continueBtn.onclick = (e) => {
            e.preventDefault();
            drawerTrigger.click();
          };
        } else if (continueBtn) {
          continueBtn.textContent = 'Continue Shopping';
          continueBtn.onclick = null;
        }
      }
    });
}


function formatMoney(cents) {
  const locale = document.documentElement.lang || 'en-US'; // get from <html lang="de"> or fallback
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: Shopify.currency.active || 'USD'
  }).format(cents / 100);
}


document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-cart-remove]');
  if (!btn) return;

  e.preventDefault();

  const clickedKey = btn.getAttribute('data-remove-key');
  const selfKey = btn.getAttribute('data-self-key');

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const keysToRemove = [clickedKey];

      if (selfKey) {
        cart.items.forEach(item => {
          const props = item.properties || {};
          if (props._tz_parent_key === selfKey) {
            keysToRemove.push(item.key);
          }
        });
      }

      const updates = {};
      keysToRemove.forEach(key => updates[key] = 0);
      console.log('🧹 Keys to remove:', keysToRemove);
      console.log('📦 Updates payload:', updates);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    })
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => {
      document.dispatchEvent(new CustomEvent('theme:cart:change', {
        detail: { cart },
        bubbles: true
      }));

      if (window.cartItems?.loadHTML) {
        console.log('🗑️ Reloading cart via cartItems.loadHTML() after delete');
        window.cartItems.loadHTML();
      }
    })
    .catch(err => {
      console.error('❌ Failed to remove cascade cart items:', err);
    });
});



document.addEventListener('DOMContentLoaded', () => {
  initEngravingUI();
  initGiftWrapUI();
  bindClosePopup();

  const plusBtn = document.querySelector('.js-atc-plus');
  const minusBtn = document.querySelector('.js-atc-minus');

  //console.log('Binduje se dugme:', plusBtn); // DEBUG

  plusBtn?.addEventListener('click', () => {
    console.log('Plus clicked');
    updatePopupQuantity(1);
  });

  minusBtn?.addEventListener('click', () => {
    console.log('Minus clicked');
    updatePopupQuantity(-1);
  });

  const atcQtyInput = document.getElementById('tz-atc-qty');
  atcQtyInput?.addEventListener('change', function () {
    if (!tzCurrentLineItemKey) return;
    const min = parseInt(document.querySelector('body')?.getAttribute('data-minimum-qty') || '1', 10);
    const normalized = normalizeB2bQuantity(this, this.value, min);
    if (parseInt(this.value, 10) !== normalized) {
      this.value = normalized;
    }
    updatePopupQuantity(0, normalized);
  });
});


function handleCartRemoveCascade(e) {
  const btn = e.target.closest('[data-cart-remove]');
  if (!btn) return;

  e.preventDefault();

  const clickedKey = btn.getAttribute('data-remove-key');
  const selfKey = btn.getAttribute('data-self-key');

  if (!clickedKey) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const keysToRemove = [];

      const mainItem = cart.items.find(item => item.key === clickedKey);
      if (mainItem) {
        keysToRemove.push(mainItem.key);
      }

      if (selfKey) {
        cart.items.forEach(item => {
          const props = item.properties || {};
          if (props._tz_parent_key === selfKey && item.key) {
            keysToRemove.push(item.key);
          }
        });
      }

      console.log('🧹 Keys to remove:', keysToRemove);

      keysToRemove.forEach((key, i) => {
        setTimeout(() => {
          try {
            if (window.cartItems && typeof window.cartItems.updateCart === 'function') {
              console.log(`🧼 Using JS API to remove: ${key}`);
              window.cartItems.updateCart(key, 0);
            } else {
              console.log(`🧼 Fallback: simulating native click for key ${key}`);
              const fallbackBtn = document.querySelector(`[data-remove-key="${key}"]`);
              fallbackBtn?.click();
            }
          } catch (err) {
            console.warn('⚠️ Failed to remove item:', key, err);
          }
        }, i * 300);
      });

      const totalDelay = keysToRemove.length * 300 + 300;
      setTimeout(() => {
        if (window.cartItems?.loadHTML) {
          console.log('🔄 Final reload via cartItems.loadHTML');
          window.cartItems.loadHTML();
        }
      }, totalDelay);
    })
    .catch(err => {
      console.error('💥 Error fetching cart.js:', err);
    });
}

document.addEventListener('click', handleCartRemoveCascade);

document.addEventListener('theme:cart:change', (e) => {
  console.log('🌀 theme:cart:change triggered, syncing children qty...');

  const cart = e.detail?.cart;

  const getCart = cart
    ? Promise.resolve(cart)
    : fetch('/cart.js').then(res => res.json());

  getCart.then((cartData) => {
    // 🔁 Sync quantities
    cartData.items.forEach(parentItem => {
      const selfKey = parentItem.properties?._tz_self_key;
      const parentQty = parentItem.quantity;

      if (!selfKey) return;

      const children = cartData.items.filter(item =>
        item.properties?._tz_parent_key === selfKey
      );

      children.forEach(child => {
        if (child.quantity !== parentQty) {
          console.log(`🔁 Syncing child ${child.key} to qty ${parentQty}`);
          try {
            if (window.cartItems?.updateCart) {
              window.cartItems.updateCart(child.key, parentQty);
            }
          } catch (err) {
            console.warn('⚠️ Failed to sync qty:', err);
          }
        }
      });
    });

    // 🗑️ Clean up orphans
    cartData.items.forEach(item => {
      const parentKey = item.properties?._tz_parent_key;
      if (!parentKey) return;

      const parentStillExists = cartData.items.some(p => p.properties?._tz_self_key === parentKey);
      console.log(parentStillExists, 'parentStillExists');

      if (!parentStillExists) {
        console.log(`🗑️ Removing orphan child: ${item.key}`);
        try {
          if (window.cartItems?.updateCart) {
            window.cartItems.updateCart(item.key, 0);
          } else {
            const fallbackBtn = document.querySelector(`[data-remove-key="${item.key}"]`);
            fallbackBtn?.click();
          }
        } catch (err) {
          console.warn('❌ Fallback removal failed for:', item.key, err);
        }
      }
    });
  }).catch(err => {
    console.error('❌ Error syncing child qty on theme:cart:change:', err);
  });
});

document.addEventListener('click', (e) => {
  const customBox = e.target.closest('.tz-checkbox-custom');
  if (customBox) {
    const wrapper = customBox.closest('.tz-checkbox-wrapper');
    const input = wrapper?.querySelector('.tz-checkbox-input');
    if (input) {
      input.checked = !input.checked;
      input.dispatchEvent(new Event('change', { bubbles: true })); // u slučaju da neko sluša change event
    }
  }
});